import React from 'react';
import { Card } from 'primereact/card';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import DemandDetailComponent from '@app/pages/carrier/demand-detail/DemandDetailComponent.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const DemandDetailPage: React.FC<ComponentProps> = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t(`Demand.demandsDetail`, `Demands detail`)}>
      {/*// @ts-ignore*/}

      <Card>
        <DemandDetailComponent />
      </Card>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(DemandDetailPage);
